
import { useState, useContext, useEffect, useMemo } from 'react'
// import { UserContext } from "./UserContext";
import ButtonBar from '../../Elements/ButtonBar'
import BulkActionsBar from '../../Elements/BulkActionsBar';
// import ListOwners from './ListOwners';
import OwnersModal from './OwnersModal';
import { UserContext } from "../../../context/UserContext";
import EmployeeModal from './EmployeeModal';
import StaffOwnerDetailModal from './StaffOwnerDetailModal';
import AddCashModal from '../../Elements/AddCashModal';
import { FaDeleteLeft } from "react-icons/fa6";
import { getImageCacheKey, getImageUrl } from '../../../lib/helpers';
import { useInVenueUsers } from '../../../context/useInVenueUsers';


const Owners = () => {
    const [imput, setImput] = useState("")
    const[loaded, setLoaded] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [token, , , venueID, , , , accessPrivileges] = useContext(UserContext);
    const[id, setId] = useState(null);
    const [scopeFilter, setScopeFilter] = useState('current');
    

    const[activeModal, setActiveModal] = useState(false);
    const[activeModalEmployee, setActiveModalEmployee] = useState(false);
    const [detailModal, setDetailModal] = useState(false);
    const [creditModal, setCreditModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [creditBalanceForModal, setCreditBalanceForModal] = useState(0);
    const [staff, setStaff] = useState([]);
    const [owners, setOwners] = useState([]);
    const { usersInVenue } = useInVenueUsers();
    const isSelectedMemberInVenue = selectedMember
      ? usersInVenue.some((u) => String(u.id) === String(selectedMember.id))
      : false;
    const [combinedList, setCombinedList] = useState([]);
    const [selectedMemberIds, setSelectedMemberIds] = useState([]);
    const [isBulkDeleting, setIsBulkDeleting] = useState(false);


    const handleInput = (e) => {
      const filtroVacio = e.target.value;
      setImput(filtroVacio);
    }

    const scopedMembers = useMemo(() => combinedList.filter((member) => {
      if (accessPrivileges !== 'superadmin') {
        return true;
      }

      const isOwner = member.userType === 'owner';
      const ownerVenueIds = Array.isArray(member.owned_venues)
        ? member.owned_venues.map((venue) => venue?.id).filter(Boolean)
        : [];
      // Staff multi-tienda: cuenta también las tiendas asignadas (venue_user_access),
      // no solo la principal — si no, un staff con principal en otra tienda
      // desaparece de "Tienda actual" aunque trabaje aquí (caso real: Marta,
      // principal Kong House + asignada a Kong Club, invisible en Kong Club).
      const staffVenueIds = Array.isArray(member.assigned_venues) ? member.assigned_venues : [];
      const isAssignedToCurrentVenue = isOwner
        ? ownerVenueIds.includes(venueID)
        : member.venue_id === venueID || staffVenueIds.includes(venueID);
      const hasVenueAssignment = isOwner ? ownerVenueIds.length > 0 : Boolean(member.venue_id);

      if (scopeFilter === 'all') {
        return true;
      }

      if (scopeFilter === 'unassigned') {
        return !hasVenueAssignment;
      }

      return isAssignedToCurrentVenue;
    }), [accessPrivileges, combinedList, scopeFilter, venueID]);

    const filtro = useMemo(() => {
      if (!scopedMembers || scopedMembers.length === 0) {
        return [];
      }

      if (!imput || imput.trim() === "") {
        return scopedMembers;
      }

      return scopedMembers.filter(member => {
        if (!member) return false;

        const firstName = member.profile?.first_name || member.first_name || member.profile?.name || member.name || '';
        const lastName = member.profile?.last_name || member.last_name || '';
        const fullName = `${firstName} ${lastName}`.trim();
        const email = member.email || '';
        const membershipId = member.membership_id != null ? String(member.membership_id).trim() : '';
        const searchTerm = imput.trim();
        const searchTermLower = searchTerm.toLowerCase();
        const isNumericSearch = /^\d+$/.test(searchTerm);

        if (isNumericSearch && membershipId) {
          return membershipId === searchTerm;
        }

        return (
          fullName.toLowerCase().includes(searchTermLower) ||
          firstName.toLowerCase().includes(searchTermLower) ||
          lastName.toLowerCase().includes(searchTermLower) ||
          email.toLowerCase().includes(searchTermLower) ||
          (membershipId && membershipId.includes(searchTerm))
        );
      });
    }, [imput, scopedMembers]);

    // Combinar staff y owners cuando cualquiera de las listas cambie
    // Owners aparecen primero en el listado
    useEffect(() => {
      const combined = [
        // Owners primero
        ...owners.map(owner => ({
          ...owner,
          userType: 'owner',
          name: owner.profile?.name || owner.profile?.first_name || owner.first_name || owner.name || 'Sin nombre',
        })),
        // Staff después
        ...staff.map(member => ({ ...member, userType: 'staff' }))
      ];
      setCombinedList(combined);
    }, [staff, owners]);

    useEffect(() => {
      setSelectedMemberIds((prev) => prev.filter((id) => combinedList.some((member) => String(member.id) === String(id))));
    }, [combinedList]);

    const staffToEdit = useMemo(() => {
      if (!id) return null;
      const sid = String(id);
      return (
        staff.find((s) => String(s.id) === sid) ||
        combinedList.find((m) => m.userType === 'staff' && String(m.id) === sid) ||
        null
      );
    }, [id, staff, combinedList]);

    const ownerToEdit = useMemo(() => {
      if (!id) return null;
      const oid = String(id);
      return (
        owners.find((o) => String(o.id) === oid) ||
        combinedList.find((m) => m.userType === 'owner' && String(m.id) === oid) ||
        null
      );
    }, [id, owners, combinedList]);

    const getStaff = async () => {
      if (!token) {
        setErrorMessage('No hay token de autenticación');
        setLoaded(true);
        return;
      }
      
      const shouldScopeToVenue = accessPrivileges !== 'superadmin';
      const url = shouldScopeToVenue && venueID
        ? `/v1/staff?venue_id=${venueID}`
        : '/v1/staff';
      
      const requestOptions = {
          method: "GET",
          headers: {
              "Content-Type":"application/json",
              Authorization: "Bearer " + token,
            },
        };
        try {
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
              const errorData = await response.json().catch(() => ({ detail: 'Error al obtener personal' }));
              setStaff([]);
              setErrorMessage(errorData.detail || 'Error al obtener personal');
              setLoaded(true);
              return;
            }
            
            const data = await response.json();
            setStaff(Array.isArray(data) ? data : []);
            setErrorMessage(""); // Limpiar errores si fue exitoso
            } catch (error) {
              console.error("❌ Error fetching staff:", error);
              setStaff([]);
              setErrorMessage(error.message || 'Error al obtener personal');
          }
      };

    const getOwners = async () => {
      if (!token) {
        setOwners([]);
        return;
      }
      
      const shouldScopeToVenue = accessPrivileges !== 'superadmin';
      const url = shouldScopeToVenue && venueID
        ? `/v1/owners?venue_id=${venueID}`
        : '/v1/owners';
      
      const requestOptions = {
          method: "GET",
          headers: {
              "Content-Type":"application/json",
              Authorization: "Bearer " + token,
            },
        };
        try {
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
              const errorData = await response.json().catch(() => ({ detail: 'Error al obtener owners' }));
              console.error('❌ Error fetching owners:', errorData);
              setOwners([]);
              return;
            }
            
        const data = await response.json();
        setOwners(Array.isArray(data) ? data : []);
            } catch (error) {
              console.error("❌ Error fetching owners:", error);
              setOwners([]);
          }
      };

    const fetchAllData = async () => {
      setLoaded(false);
      try {
        await Promise.all([getStaff(), getOwners()]);
      } catch (error) {
        console.error('❌ Error in fetchAllData:', error);
      } finally {
        setLoaded(true);
      }
    };

      const handleDelete = async (id) => {
          // Encontrar el miembro para determinar si es owner o staff
          const member = combinedList.find(m => m.id === id);
          const isOwner = member?.userType === 'owner';
          
          // Confirmar antes de eliminar
          const confirmMessage = isOwner 
            ? '¿Estás seguro de que quieres eliminar este propietario?'
            : '¿Estás seguro de que quieres eliminar este miembro del personal?';
          
          if (!window.confirm(confirmMessage)) {
              return;
          }
          
          try {
              const requestOptions = {
                method: "DELETE",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              };
              
              // Usar el endpoint correcto según el tipo
              const endpoint = isOwner ? `/v1/owners/${id}` : `/v1/staff/${id}`;
              const response = await fetch(endpoint, requestOptions);
              
              if (!response.ok) {
                  const errorData = await response.json().catch(() => ({ detail: `Error al eliminar ${isOwner ? 'propietario' : 'personal'}` }));
                  setErrorMessage(errorData.detail || `Error al eliminar ${isOwner ? 'propietario' : 'personal'}`);
                  return;
              }
              
              // Recargar lista
              await fetchAllData();
              setErrorMessage(""); // Limpiar errores si fue exitoso
          } catch (error) {
              console.error(`Error deleting ${isOwner ? 'owner' : 'staff'}:`, error);
              setErrorMessage(error.message || `Error al eliminar ${isOwner ? 'propietario' : 'personal'}`);
          }
        }

      const toggleSelectedMember = (id) => {
        setSelectedMemberIds((prev) =>
          prev.some((currentId) => String(currentId) === String(id))
            ? prev.filter((currentId) => String(currentId) !== String(id))
            : [...prev, id]
        );
      };

      const clearSelectedMembers = () => setSelectedMemberIds([]);

      const selectVisibleMembers = () => setSelectedMemberIds(filtro.map((member) => member.id));

      const deleteMemberById = async (id) => {
        const member = combinedList.find((item) => String(item.id) === String(id));
        const isOwner = member?.userType === 'owner';
        const response = await fetch(isOwner ? `/v1/owners/${id}` : `/v1/staff/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ detail: `Error al eliminar ${isOwner ? 'propietario' : 'personal'}` }));
          throw new Error(errorData.detail || `Error al eliminar ${isOwner ? 'propietario' : 'personal'}`);
        }
      };

      const handleBulkDelete = async () => {
        if (!selectedMemberIds.length) return;
        if (!window.confirm(`¿Eliminar ${selectedMemberIds.length} elementos de personal seleccionados?`)) return;

        setIsBulkDeleting(true);
        const results = await Promise.allSettled(selectedMemberIds.map(deleteMemberById));
        const failedCount = results.filter((result) => result.status === 'rejected').length;
        await fetchAllData();
        setIsBulkDeleting(false);
        setSelectedMemberIds([]);

        if (failedCount > 0) {
          setErrorMessage(`Se eliminaron ${selectedMemberIds.length - failedCount} elementos y ${failedCount} fallaron.`);
          return;
        }

        setErrorMessage("");
      };

      const handleModal = () => {
        setId(null);
        setActiveModal(!activeModal);
        if (!activeModal) {
          // Si se está cerrando el modal, recargar datos
          fetchAllData();
        }
      }
      
      const handleModalEmployee = () => {
        setId(null);
        setActiveModalEmployee(!activeModalEmployee);
        if (!activeModalEmployee) {
          // Si se está cerrando el modal, recargar datos
          fetchAllData();
        }
      }
      
      const handleEdit = (id) => {
        const member = combinedList.find((m) => String(m.id) === String(id));
        if (member && member.userType === 'owner') {
          setId(id);
          setActiveModal(true);
        } else {
          // Para staff, usar EmployeeModal
          setId(id);
          setActiveModalEmployee(true);
        }
      }
      
      
        useEffect(() => {
          if (token) {
            fetchAllData();
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [token, venueID]);
        const menu_bar = [
          {
                title: 'Personal',
                buttons: [
                  {
                    label: 'Crear Trabajador',
                    color: 'green',
                    onClick: () => {
                    setId(null);
                    setActiveModalEmployee(true)
                    },
                  },
                  {
                    label: 'Crear Propietario de Tienda',
                    color: 'green',
                    onClick: () => {
                    setId(null);
                    setActiveModal(true)
                    // Modal abierto
                    },
                  },
            ],
         },
     ];

        return (
        <div className="p-3 sm:p-4 space-y-3 sm:space-y-4 max-w-full">
            {accessPrivileges === 'superadmin' && (
              <div className="bg-white rounded-lg border border-gray-200 p-3 flex flex-wrap gap-2">
                <button
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    scopeFilter === 'current' ? 'bg-violet-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  onClick={() => setScopeFilter('current')}
                >
                  Tienda actual
                </button>
                <button
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    scopeFilter === 'all' ? 'bg-violet-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  onClick={() => setScopeFilter('all')}
                >
                  Todas
                </button>
                <button
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    scopeFilter === 'unassigned' ? 'bg-violet-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  onClick={() => setScopeFilter('unassigned')}
                >
                  Sin tienda
                </button>
              </div>
            )}

            {/* Desktop: barra normal */}
            <div className="hidden lg:block">
              {menu_bar.map((menuItem, index) => (
               <ButtonBar
                key={index}
                title={menuItem.title}
                buttons={menuItem.buttons}
               />
              ))}
            </div>
            {/* Móvil: botones alargados para Personal */}
            <div className="block lg:hidden bg-white p-4 rounded-lg shadow border border-gray-200 mb-3 space-y-3">
              <h2 className="text-xl font-semibold text-gray-800">
                Personal
              </h2>
              <div className="space-y-2">
                <button
                  className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all active:scale-95"
                  onClick={() => { setId(null); setActiveModalEmployee(true); }}
                >
                  Crear Trabajador
                </button>
                <button
                  className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-green-500 hover:bg-green-600 text-white rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all active:scale-95"
                  onClick={() => { setId(null); setActiveModal(true); }}
                >
                  Crear Propietario de Tienda
                </button>
              </div>
            </div>

         {errorMessage && (
           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
             <strong className="font-bold">Error: </strong>
             <span className="block sm:inline">{errorMessage}</span>
             <button
               className="absolute top-0 bottom-0 right-0 px-4 py-3"
               onClick={() => setErrorMessage("")}
             >
               <span className="text-red-700">×</span>
             </button>
           </div>
         )}

         {!loaded && (
           <div className="flex items-center justify-center p-8">
             <div className="text-center">
               <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
               <p className="mt-2 text-gray-600">Cargando personal...</p>
             </div>
           </div>
         )}

            <div className='bg-white justify-left shadow-2xl'>
              <div className="bg-white p-3 sm:p-4 rounded-lg flex items-center border border-gray-200 justify-between rounded">
                <input
                  className="text-sm focus:outline-none active:outline-none border border-gray-300 w-full h-10 pl-11 pr-4 rounded"
                  onChange={handleInput}
                  placeholder="Buscar por: Nombre, Apellidos, Email o NºSocio..."
                  value={imput}
                />
              </div>
            </div>

            <BulkActionsBar
              selectedCount={selectedMemberIds.length}
              onClear={clearSelectedMembers}
              onSelectAll={selectVisibleMembers}
              onDelete={handleBulkDelete}
              deleteLabel="Eliminar personal"
              disabled={isBulkDeleting}
            />

            {/* Vista de tarjetas para móvil - igual que Socios */}
            <div className="block lg:hidden space-y-3">
              {!loaded ? (
                <div className="bg-white rounded-lg shadow border p-8 text-center text-gray-500">
                  Cargando personal...
                </div>
              ) : filtro.length === 0 ? (
                <div className="bg-white rounded-lg shadow border p-8 text-center text-gray-500">
                  {imput === "" ? "No hay personal disponible" : "No se encontraron resultados"}
                </div>
              ) : (
                filtro.map((member) => {
                  const isOwner = member.userType === 'owner';
                  const imageUrl = getImageUrl(member.profile?.documents_path, {
                    cacheKey: getImageCacheKey(isOwner ? 'owner' : 'staff', member.id),
                  });
                  const displayName = member.profile?.first_name && member.profile?.last_name
                    ? `${member.profile.first_name} ${member.profile.last_name}`
                    : member.profile?.name && member.profile?.last_name
                    ? `${member.profile.name} ${member.profile.last_name}`
                    : (member.first_name || member.last_name)
                    ? `${member.first_name || ''} ${member.last_name || ''}`.trim()
                    : member.email;
                  return (
                    <div
                      key={`${member.userType || 'staff'}-${member.id}`}
                      className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md hover:border-purple-300 transition-all duration-200"
                    >
                      <div className="mb-3 flex justify-end">
                        <input
                          type="checkbox"
                          checked={selectedMemberIds.some((id) => String(id) === String(member.id))}
                          onChange={() => toggleSelectedMember(member.id)}
                          className="h-4 w-4 accent-purple-600"
                        />
                      </div>
                      <div
                        className="flex items-center gap-3 mb-4 cursor-pointer group"
                        onClick={() => {
                          setSelectedMember(member);
                          setDetailModal(true);
                        }}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={displayName}
                            className="w-32 h-32 rounded-xl object-cover border-2 border-gray-200 group-hover:border-purple-400 transition-colors flex-shrink-0"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div
                          className={`w-32 h-32 rounded-xl bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center text-white font-bold text-2xl text-3xl shadow-sm flex-shrink-0 ${imageUrl ? 'hidden' : 'flex'}`}
                        >
                          {displayName.charAt(0).toUpperCase()}
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-bold text-gray-900 truncate text-base group-hover:text-purple-600 transition-colors">
                            {displayName}
                          </div>
                          <div className="text-xs text-gray-500 truncate mt-0.5">{member.email}</div>
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-3 mb-4">
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="flex flex-col">
                            <span className="text-xs text-gray-500 mb-0.5">Nº Socio</span>
                            <span className="font-semibold text-gray-900">{member.membership_id ?? '-'}</span>
                          </div>
                          <div className="flex flex-col">
                            <span className="text-xs text-gray-500 mb-0.5">Saldo</span>
                            <span className="font-bold text-green-600 text-base">€{(Number(member.profile?.credit_balance) || 0).toFixed(2)}</span>
                          </div>
                          <div className="flex flex-col col-span-2">
                            <span className="text-xs text-gray-500 mb-0.5">Tipo</span>
                            <span className={`px-2 py-1 text-xs font-semibold rounded-full w-fit ${isOwner ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                              {isOwner ? 'Propietario' : 'Personal'}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-2">
                        {(!isOwner || accessPrivileges === 'superadmin') && (
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDelete(member.id); }}
                          className="w-full flex items-center justify-center gap-2 px-3 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all active:scale-95"
                        >
                          <FaDeleteLeft className="text-sm" />
                          <span>Eliminar</span>
                        </button>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* Vista de tabla para desktop - igual que Socios */}
            <div className="hidden lg:block overflow-x-auto bg-white rounded-lg shadow border">
        <table className="min-w-full text-sm text-gray-700">
          <thead className="bg-gray-50 uppercase text-xs">
            <tr>
              <th className="px-4 py-3 text-left w-12">
                <span className="sr-only">Seleccionar</span>
              </th>
              <th className="px-4 py-3 text-left">Socio</th>
              <th className="px-4 py-3 text-left">Nº Socio</th>
              <th className="px-4 py-3 text-left">Saldo</th>
              <th className="px-4 py-3 text-left">Tipo</th>
              <th className="px-4 py-3 text-right">
                <div className="flex justify-end gap-2">
                  <span className="text-left text-gray-700" style={{ width: '152px' }}>Acciones</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loaded ? (
              <tr>
                <td colSpan={5} className="py-8 text-center text-gray-500">
                  Cargando personal...
                </td>
              </tr>
            ) : (
              filtro.map((member) => {
                const isOwner = member.userType === 'owner';
                const imageUrl = getImageUrl(member.profile?.documents_path, {
                  cacheKey: getImageCacheKey(isOwner ? 'owner' : 'staff', member.id),
                });
                const displayName = member.profile?.first_name && member.profile?.last_name
                  ? `${member.profile.first_name} ${member.profile.last_name}`
                  : member.profile?.name && member.profile?.last_name
                  ? `${member.profile.name} ${member.profile.last_name}`
                  : (member.first_name || member.last_name)
                  ? `${member.first_name || ''} ${member.last_name || ''}`.trim()
                  : member.email;
                return (
                  <tr key={`${member.userType || 'staff'}-${member.id}`} className="even:bg-white odd:bg-gray-50 hover:bg-gray-100 transition-colors">
                    <td className="px-4 py-4 align-middle">
                      <input
                        type="checkbox"
                        checked={selectedMemberIds.some((id) => String(id) === String(member.id))}
                        onChange={() => toggleSelectedMember(member.id)}
                        className="h-4 w-4 accent-purple-600"
                      />
                    </td>
                    <td className="px-4 py-4 align-middle">
                      <div
                        className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={() => {
                          setSelectedMember(member);
                          setDetailModal(true);
                        }}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={displayName}
                            className="w-12 h-12 rounded-full object-cover border border-gray-300 flex-shrink-0"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div
                          className={`w-12 h-12 rounded-xl bg-gray-300 flex items-center justify-center text-gray-600 font-semibold flex-shrink-0 ${imageUrl ? 'hidden' : 'flex'}`}
                        >
                          {displayName.charAt(0).toUpperCase()}
                        </div>
                        <div className="min-w-0">
                          <div className="font-semibold text-gray-900 truncate">{displayName}</div>
                          <div className="text-xs text-gray-500 truncate">{member.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4 align-middle">
                      <span className="font-medium">{member.membership_id ?? '-'}</span>
                    </td>
                    <td className="px-4 py-4 align-middle">
                      <span className="font-semibold text-green-600">€{(Number(member.profile?.credit_balance) || 0).toFixed(2)}</span>
                    </td>
                    <td className="px-4 py-4 align-middle">
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${isOwner ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {isOwner ? 'Propietario' : 'Personal'}
                      </span>
                    </td>
                    <td className="px-4 py-4 align-middle">
                      <div className="flex items-center justify-end gap-2">
                        {(!isOwner || accessPrivileges === 'superadmin') && (
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDelete(member.id); }}
                          className="flex items-center justify-center gap-2 px-3 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all active:scale-95"
                          title="Eliminar"
                        >
                          <FaDeleteLeft />
                          <span>Eliminar</span>
                        </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
            {filtro.length === 0 && loaded && (
              <tr>
                <td colSpan={5} className="py-8 text-center text-gray-500">
                  {imput === "" ? "No hay personal disponible" : "No se encontraron resultados"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

         <OwnersModal
           active={activeModal}
           handleModal={handleModal}
           token={token}
           id={id}
           ownerData={ownerToEdit}
           setErrorMessage={setErrorMessage}
           onSuccess={(data) => {
             if (data?.id) {
               setOwners((prev) =>
                 prev.map((o) =>
                   String(o.id) === String(data.id)
                     ? { ...o, ...data, profile: { ...(o.profile || {}), ...(data.profile || {}) } }
                     : o,
                 ),
               );
             }
             fetchAllData();
             if (data?.id && String(selectedMember?.id) === String(data.id)) {
               setSelectedMember((prev) => ({ ...prev, ...data, profile: { ...(prev?.profile || {}), ...(data.profile || {}) } }));
             }
           }}
           />
        <EmployeeModal
          active={activeModalEmployee}
          handleModal={handleModalEmployee}
          token={token}
          id={id}
          staffData={staffToEdit}
          setErrorMessage={setErrorMessage}
          onSuccess={(data) => {
            if (data?.id) {
              setStaff((prev) =>
                prev.map((s) =>
                  String(s.id) === String(data.id)
                    ? { ...s, ...data, profile: { ...(s.profile || {}), ...(data.profile || {}) } }
                    : s,
                ),
              );
            }
            fetchAllData();
            if (data?.id && String(selectedMember?.id) === String(data.id)) {
              setSelectedMember((prev) => ({ ...prev, ...data, profile: { ...(prev?.profile || {}), ...(data.profile || {}) } }));
            }
          }}
          />

        <StaffOwnerDetailModal
          active={detailModal}
          handleModal={() => {
            setDetailModal(false);
            setSelectedMember(null);
          }}
          member={selectedMember}
          token={token}
          venueID={venueID}
          isMemberInVenue={isSelectedMemberInVenue}
          onEdit={() => {
            if (selectedMember) {
              handleEdit(selectedMember.id);
            }
          }}
          onDelete={
            (!selectedMember || selectedMember.userType !== 'owner' || accessPrivileges === 'superadmin')
              ? () => { if (selectedMember) handleDelete(selectedMember.id); }
              : undefined
          }
          onAddCredit={() => {
            if (selectedMember) {
              setId(selectedMember.id);
              setCreditBalanceForModal(Number(selectedMember?.profile?.credit_balance) || 0);
              setCreditModal(true);
            }
          }}
        />

        <AddCashModal
          active={creditModal}
          handleAddCashModal={() => {
            setCreditModal(false);
            setId(null);
            setCreditBalanceForModal(0);
          }}
          token={token}
          user_id={id}
          venueID={venueID}
          setErrorMessage={setErrorMessage}
          currentBalance={creditBalanceForModal}
          onCashAdded={(userId, newBalance) => {
            // Recargar datos después de agregar crédito
            fetchAllData();
            setCreditModal(false);
            setId(null);
            setCreditBalanceForModal(0);
          }}
        />


    </div>
        )
    }
    
export default Owners
